import axios from 'axios'
import DiagnosisOptionsTransformer from 'transformers/DiagnosisOptionsTransformer'

export default {
    getFromICD(searchTerm, searchField) {
        return axios.get('icd-codes', {
            params: {
                query: searchTerm,
                searchField: searchField,
            },
            transformResponse: [DiagnosisOptionsTransformer.transform('id', 'name')],
        })
    },
}
